"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _createForOfIteratorHelper2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/createForOfIteratorHelper.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/web.dom.iterable");
var _path = _interopRequireDefault(require("path"));
var _utils = require("@/utils");
var _permission = require("@/utils/permission");
var role = _interopRequireWildcard(require("@/api/role"));
var _router = require("@/router");
var _AddRole = _interopRequireDefault(require("./components/AddRole"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    AddRole: _AddRole.default
  },
  data: function data() {
    return {
      configSystem: process.env.VUE_APP_CONFIG_SYSTEM,
      dialogLoading: false,
      role: {
        name: "",
        permissions: []
      },
      tableLoading: false,
      routes: [],
      rolesList: [],
      dialogVisible: false,
      dialogType: "new",
      checkStrictly: false,
      loadingUpdate: false,
      permissionsList: [],
      defaultProps: {
        children: "children",
        label: "title"
      }
    };
  },
  computed: {
    routesData: function routesData() {
      return this.routes;
    },
    defaultCheck: function defaultCheck() {
      var res = [];
      if (this.role) this.role.permissions.forEach(function (element) {
        res.push(element.path);
      });
      return res;
    }
  },
  created: function created() {
    this.getRoutes();
    this.getRoles();
    // this.getAllPermission();
  },
  methods: {
    getAllPermission: function getAllPermission() {
      var _this = this;
      role.getPermissions().then(function (res) {
        _this.permissionsList = res.data;
      });
    },
    importRoutesPath: function importRoutesPath() {
      var _this2 = this;
      var res = (0, _permission.generateRoutesPath)();
      var data = {
        permissions: res
      };
      role.importRoutesPath(data).then(function () {
        _this2.$message({
          type: "success",
          message: "Cập nhật menu thành công"
        });
      });
    },
    getRoutes: function getRoutes() {
      this.routes = this.generateRoutes(_router.constantRoutes);
    },
    getRoles: function () {
      var _getRoles = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.tableLoading = true;
              _context.next = 3;
              return role.getRoles();
            case 3:
              res = _context.sent;
              this.tableLoading = false;
              this.rolesList = res.data.data;
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getRoles() {
        return _getRoles.apply(this, arguments);
      }
      return getRoles;
    }(),
    // Reshape the routes structure so that it looks the same as the sidebar
    generateRoutes: function generateRoutes(routes) {
      var basePath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "/";
      var res = [];
      var _iterator = (0, _createForOfIteratorHelper2.default)(routes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var route = _step.value;
          // skip some route
          if (route.hidden) {
            continue;
          }
          var data = {
            path: _path.default.resolve(basePath, route.path),
            title: route.meta && route.meta.title
          };

          // recursive child routes
          if (route.children) {
            data.children = this.generateRoutes(route.children, data.path);
          }
          res.push(data);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return res;
    },
    handleEdit: function () {
      var _handleEdit = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(scope) {
        var _this3 = this;
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.dialogType = "edit";
              this.dialogVisible = true;
              this.dialogLoading = true;
              _context2.next = 5;
              return role.getPermission(scope.row.id);
            case 5:
              res = _context2.sent;
              this.dialogLoading = false;
              this.role = res.data;
              this.checkStrictly = true;
              this.$nextTick(function () {
                _this3.checkStrictly = false;
              });
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function handleEdit(_x) {
        return _handleEdit.apply(this, arguments);
      }
      return handleEdit;
    }(),
    confirmRole: function confirmRole() {
      var _this4 = this;
      var permissionsCheck = this.$refs["tree"].getCheckedNodes();
      var res = this.permissionsList.filter(function (item) {
        return permissionsCheck.some(function (per) {
          return item.path == per.path;
        });
      });
      var data = {
        permissions: res,
        info: this.role
      };
      this.loadingUpdate = true;
      role.updatePermission(this.role.id, data).then(function (res) {
        var _this4$role = _this4.role,
          description = _this4$role.description,
          name = _this4$role.name;
        _this4.dialogVisible = false;
        _this4.$notify({
          title: "Thành công",
          type: "success"
        });
      }).finally(function () {
        _this4.loadingUpdate = false;
      });
    }
  }
};